import { useContext, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { LocaleContext } from 'contexts/locale/localeContext/localeContext';

export const useLocale = () => {
  const intl = useIntl();
  const context = useContext(LocaleContext);

  if (context === undefined) {
    throw new Error('useLocale must be used within an LocaleContext');
  }

  const locale = useMemo(
    () => ({
      ...intl,
      ...context,
    }),
    [intl, context],
  );

  return locale;
};
